import Nullstack from 'nullstack';
export default function IconPhotoEdit({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-photo-edit",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M15 8h.01"
  }), "   ", Nullstack.element("path", {
    d: "M11 20h-4a3 3 0 0 1 -3 -3v-10a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v4"
  }), "   ", Nullstack.element("path", {
    d: "M4 15l4 -4c.928 -.893 2.072 -.893 3 0l3 3"
  }), "   ", Nullstack.element("path", {
    d: "M14 14l1 -1c.31 -.298 .644 -.497 .987 -.596"
  }), "   ", Nullstack.element("path", {
    d: "M18.42 15.61a2.1 2.1 0 0 1 2.97 2.97l-3.39 3.42h-3v-3l3.42 -3.39z"
  }), " ");
}